import axios from 'axios';
import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';

import successHandle from '../utils/successHandle';
import errorHandle from '../utils/errorHandle';
import { checkAuthPage } from '../utils/utils';

const apiEndPoint = process.env.REACT_APP_API_URL + "/api/user/subscribe";
const EMAIL_REGEX_PATTERN = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;

const Footer = () => {
	const intialState = { email: '', loading: false }
	const [state, setCompleteState] = useState(intialState)
	const {pathname: pathName} = useLocation();
	const isAuthPage = checkAuthPage(pathName);

	if (isAuthPage) {
		return <></>;
	}

	const setState = (newState) =>
		setCompleteState((prevState) => ({ ...prevState, ...newState }));

	const validateEmail = (email) => {
		const isValidEmail = EMAIL_REGEX_PATTERN.test(email);
		return isValidEmail;
	};

	const handleSubmit = (e) => {
		e.preventDefault();
		subscribeNewsLetter();
	};

	const subscribeNewsLetter = async () => {
		const { email } = state;
		if (!email) {
			toast.error("Please enter Email", { position: "bottom-right" });
			return;
		}

		const validEmail = validateEmail(email);
		if (!validEmail) {
			toast.error("Invalid Email!", { position: "bottom-right" });
			return;
		}

		setState({ loading: true })
		const data = { email }
		await axios.post(apiEndPoint, data)
			.then((res) => {
				setState({ loading: false });
				successHandle(res?.data?.message);
			})
			.catch((err) => {
				setState({ loading: false })
				errorHandle(err)
			})
	}

	return (
		<div>
			<footer id="footer">
				{pathName === '/' && (
					<div class="footer-newsletter">
						<div class="container">
							<div class="row justify-content-center">
								<div class="col-lg-6">
									<h4>Join Our Newsletter</h4>
									<p>Subscribe our newsletter for getting latest updates on your email</p>
									<form onSubmit={handleSubmit}>
										<input type="email" className='form-control' name="email" value={state?.email} onChange={(e) => setState({ email: e.target.value })} />
										<input type="submit" disabled={state.loading} value="Subscribe" onClick={handleSubmit} />
									</form>
								</div>
							</div>
						</div>
					</div>
				)}

				<div class="footer-top">
					<div class="container">
						<div class="row">
							<div class="col-lg-3 col-md-6 footer-contact">
								<div className='fs-20 fw-500'>Gleamdesk</div>
								<div>
									<div className='address my-2'>
										Plot No 23, Bomikhal, Jharapada, Bhubaneswar, Odisha 751010 Bhubaneswar - 751002.
									</div>
									<div className='open-time my-2'>
										<strong className='mr-1'>Opens at</strong>
										09:00 AM
									</div>
									<div className='my-2 phone'>
										<strong className='mr-1'>Phone:</strong>
										<a href="tel:+917077177979" className='fs-16'>+91 70771 77979</a>
									</div>
									<div className='my-2 email'>
										<strong className='mr-1'>Email:</strong>
										<a href="mailto:contactus@gleamdesk.com" className='fs-16'>
											contactus@gleamdesk.com
										</a>
									</div>
								</div>
							</div>

							<div class="col-lg-3 col-md-6 footer-links">
								<h4>Useful Links</h4>
								<ul>
									<li><i class="bx bx-chevron-right"></i> <Link to="/">Home</Link></li>
									<li><i class="bx bx-chevron-right"></i> <Link to="/about">About us</Link></li>
									<li><i class="bx bx-chevron-right"></i> <Link to="/appointments">appointments</Link></li>
									<li><i class="bx bx-chevron-right"></i> <Link to="/products">Products</Link></li>
								</ul>
							</div>

							<div class="col-lg-3 col-md-6 footer-links">
								<h4>Our Services</h4>
								<ul>
									<li><i class="bx bx-chevron-right"></i> <a href="#">Dedicated Relationship Managers</a></li>
									<li><i class="bx bx-chevron-right"></i> <a href="#">Portfolio management service</a></li>
									<li><i class="bx bx-chevron-right"></i> <a href="#">Cetralized Help Desk</a></li>
									<li><i class="bx bx-chevron-right"></i> <a href="#">Call Support</a></li>
								</ul>
							</div>

							<div class="col-lg-3 col-md-6 footer-links">
								<h4>Our Social Networks</h4>
								<p>Follow us for all the latest updates across our social networks!</p>
								<div class="social-links mt-3">
									<a href="#" class="twitter"><i class="bx bxl-twitter"></i></a>
									<a href="#" class="facebook"><i class="bx bxl-facebook"></i></a>
									<a href="#" class="instagram"><i class="bx bxl-instagram"></i></a>
									<a href="#" class="google-plus"><i class="bx bxl-skype"></i></a>
									<a href="#" class="linkedin"><i class="bx bxl-linkedin"></i></a>
								</div>
							</div>

						</div>
					</div>
				</div>

				<div class="container py-4">
					<div class="copyright">
						&copy; Copyright <strong><span>MappingNinja</span></strong>. All Rights Reserved
					</div>
					<div class="credits">
						Designed by <a href="https://mappingninja.solutions" target='_blank'>MappingNinja</a>
					</div>
				</div>
			</footer>
		</div>
	)
}

export default Footer;
